module.exports = __webpack_public_path__ + "img/_old_logo.4d0f7809.svg";